import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = { reservationId: number };
export type ValidateInsuranceResponse = {
  message: string;
  data: { manualInsuranceStatus: string };
};

export const useValidateInsurance = createMutation<
  ValidateInsuranceResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/customers/insurance/validate',
      method: 'POST',
      data: {
        reservation_id: variables.reservationId,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
